import { Button, Code, Group, Stack } from '@mantine/core';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { EmptyState } from '@web/ui/EmptyState';

/** Route `errorElement`: 404s, render errors and stale chunks after a deployment. */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const message = error instanceof Error ? error.message : isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : String(error);
  const staleChunk = /dynamically imported module|Failed to fetch|Importing a module script failed/i.test(message);
  return (
    <Stack p="xl">
      <EmptyState
        icon={IconAlertTriangle}
        title={is404 ? t('common:errors.notFoundTitle') : staleChunk ? t('common:errors.newVersion') : t('common:errors.unexpected')}
        description={is404 ? t('common:errors.notFoundText') : staleChunk ? t('common:errors.newVersionText') : <Code dir="ltr">{message}</Code>}
        action={
          <Group>
            <Button leftSection={<IconRefresh size={16} aria-hidden />} onClick={() => window.location.reload()}>
              {t('common:actions.reload')}
            </Button>
            <Button component={Link} to="/" variant="light">
              {t('common:nav.backHome')}
            </Button>
          </Group>
        }
      />
    </Stack>
  );
}
